import React, { useState, useEffect } from "react";
import { UploadOutlined } from '@ant-design/icons';
import { Form, Input, Button, Row, Col, Card, Image, Upload, notification, Space } from "antd";
import {useLocation} from 'react-router-dom'
import FormData from 'form-data'
import axios from 'axios'
import { ChromePicker } from 'react-color'

const {TextArea} = Input

const Detail = () => {
    const token = localStorage.getItem("token")
    const loc = useLocation()
    const [title, settitle] = useState("")
    const [subtitle, setsubtitle] = useState("")
    const [benefit_icon, seticon] = useState("")
    const [title_color, setcolor] = useState("")
    const [prevUrl, setprev] = useState("")
    const [oriData, setoridata] = useState({})
    const [loading, setLoading] = useState(false)

    const getData = async (id) => {
        let fetch = await axios.get('https://api.rajarental.co.id/api/v1.0/admin/benefit/' + id, {headers: {
          Authorization: token
        }})

        if(fetch) {
            let data = fetch.data.response
            console.log(fetch.data.response)
            seticon(data.icon_source)
            setprev(data.icon_source)
          setoridata({...data, benefit_icon: data.icon_source})
          settitle(data.title)
          setsubtitle(data.subtitle)
          setcolor(data.title_color)
        }
      }

      useEffect(() => {
        if(loc.search && loc.search !== "") {
            getData(loc.search.split("?")[1].split("=")[1])
        }
      }, [])

      const submitForm = async (e) => {
          try {
              setLoading(true)
              e.preventDefault()
              if(loc.search && loc.search !== "") {
                  let id = loc.search.split("?")[1].split("=")[1]
                  let body = new FormData()
                  let state = {
                      title,
                      subtitle,
                      title_color,
                      benefit_icon
                  }
                  console.log(state, 'keyyy')
                  for(let key in state) {
                      if((oriData[key] != state[key]) && state[key] !== undefined) {
                          body.append(key,state[key])
                          console.log(key, 'bedaa')
                      }
                  }

                  if(title !== "" &&
                    subtitle !== ""
                ) {
                      let update = await axios.put('https://api.rajarental.co.id/api/v1.0/admin/benefit/' + id,
                          body,{headers: {
                        Authorization: token,
                        'Content-Type': `multipart/form-data; boundary=${body._boundary}`,
                    }})

                    if(update) {
                        setLoading(false)
                        notification["success"]({
                            message: "Success Edit Benefit detail",
                        });
                        // console.log(update)
                        window.location.href = "/dashboard/benefit"
                    }
                  } else {
                    setLoading(false)
                    notification["warning"]({
                        message: "Semua field wajib diisi",
                        description:
                          "Please try again",
                      });
                  }
                  
              }
          } catch (error) {

            console.log(error)
            setLoading(false)
            notification["warning"]({
                message: "Error",
                description:
                  "Please try again",
              });
          }
      }

      const changeImg = async ({ file, fileList }) => {
        if (file.status !== 'uploading') {
            seticon(file)
            const src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
        
                reader.onloadend = () => resolve(reader.result);
              });

              setprev(src)
            console.log(file);
        }
    }
    // console.log(username)

    return (
        <React.Fragment>
            <Card size="small" style={{padding: "20px 30px"}}>
                <Row justify="space-between">
                    <Col span={11} style={{marginBottom: 10}}>
                        <p style={{marginBottom: 5}}>Title</p>
                        <Input value={title} onChange={(e) => settitle(e.target.value)}/>
                    </Col>
                    
                    <Col span={11} style={{marginBottom: 10}}>
                        <p style={{marginBottom: 5}}>Subtitle</p>
                        <Input value={subtitle} onChange={(e) => setsubtitle(e.target.value)}/>
                    </Col>

                    <Col span={11} style={{marginBottom: 10}}>
                    <p style={{marginBottom: 5}}>Title Color</p>
                    <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            border: '1px solid #d9d9d9',
                            borderRadius: '2px',
                            padding: '4px 11px',
                            height: 32,
                            marginBottom: 25
                        }} wrap>
                            {title_color}
                        </div>
                        <ChromePicker color={title_color} onChangeComplete={(color) => setcolor(color.hex)}/>
                    </Col>

                    <Col span={11} style={{marginBottom: 10}}>
                        <p style={{marginBottom: 5}}>Icon</p>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                            border: '1px solid #d9d9d9',
                            borderRadius: '2px',
                            paddingLeft: '11px',
                        }} wrap>
                            <div style={{width: '73%'}}>
                                <p className="elipsis" style={{marginBottom: '0px', marginTop: '4px'}}>{benefit_icon?.name ? benefit_icon.name : benefit_icon}</p>
                            </div>
                            
                            <Upload 
                            style={{height: '100%'}}
                            showUploadList={false}
                            beforeUpload={() => {
                                return false;
                              }}                      
                            onChange={changeImg}>
                                <Button style={{borderWidth: 0, borderLeftWidth: '1px', height: '100%'}} icon={<UploadOutlined />}>Upload</Button>
                            </Upload>
                        </div>
                        <Image src={prevUrl} style={{marginTop: '20px'}}/>
                    </Col>
 
                    <Col span={24}>
                        <Button style={{float: 'right', marginTop: 25}} type="primary" loading={loading} onClick={submitForm}>Submit</Button>
                    </Col>
                    
                </Row>
            </Card>
        </React.Fragment>
    )
}

export default Detail